module.exports = __webpack_public_path__ + "img/3.ee3afd46.jpg";